import { ConvertStablesDialogContentContainer } from './ConvertStablesDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface ConvertStablesDialogProps extends CommonDialogProps {
  proceedText: string
}

function ConvertStablesDialog({ open, setOpen, proceedText }: ConvertStablesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <ConvertStablesDialogContentContainer closeDialog={() => setOpen(false)} proceedText={proceedText} />
      </DialogContent>
    </Dialog>
  )
}

export const convertStablesDialogConfig: DialogConfig<ConvertStablesDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: ConvertStablesDialog,
  name: 'ConvertStablesDialog',
}
